import React, { Component } from 'react';
import { Form, Input, Popconfirm, InputNumber, Button, Table } from "antd";



// We import our firestore module
import { db, storr } from '../firebase/firebase';
import moment from 'moment';



const data = [];

//=================editable==========================
const FormItem = Form.Item;
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
    <EditableContext.Provider value={form}>
        <tr {...props} />
    </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);
//=================editable==========================



class EditableCell extends React.Component {
    getInput = () => {
        if (this.props.inputType === 'number') {
            return <InputNumber />;
        }
        return <Input />;
    };

    render() {
        const {
            editing,
            dataIndex,
            title,
            inputType,
            record,
            index,
            ...restProps
        } = this.props;
        return (
            <EditableContext.Consumer>
                {(form) => {
                    const { getFieldDecorator } = form;
                    return (
                        <td {...restProps}>
                            {editing ? (
                                <FormItem style={{ margin: 0 }}>
                                    {getFieldDecorator(dataIndex, {
                                        rules: [{
                                            required: true,
                                            message: `Please Input ${title}!`,
                                        }],
                                        initialValue: record[dataIndex],
                                    })(this.getInput())}
                                </FormItem>
                            ) : restProps.children}
                        </td>
                    );
                }}
            </EditableContext.Consumer>
        );
    }
}


class Media extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checky: false,
            selectedFile: null,
            disallow: true,
            downloadlink: "",
            data,
            dd: null,
            da: null,
            ta: null,
            na: null,
            la: null,
            master: [],
            sd: [],
            editingKey: ''
        };
        this.columns = [
            // {
            //     title: 'Actual file name',
            //     dataIndex: 'actualfilename',
            //     editable: true,
            //     sorter: (a, b) => { return a.actualfilename.localeCompare(b.actualfilename) },
            // },
            {
                title: 'File name',
                dataIndex: 'name',
                editable: true,
                sorter: (a, b) => { return a.name.localeCompare(b.name) },
            },
            // {
            //     title: 'Link',
            //     dataIndex: 'link',
            //     width: '20%',
            // },
            {
                title: 'Upload Date',
                dataIndex: 'date',
                sorter: (a, b) => { return a.date.localeCompare(b.date) },
            },
            {
                title: 'Media Link',
                dataIndex: 'link',
                editable: false,
                render: (text, record) => {
                    return (
                        <div>
                            <Button
                                type="primary"
                                onClick={evt => this.openlink(record.key)}>
                                {/* {this.state.data[record.key].date} */}
                                View Media
                            </Button>
                        </div>
                    );
                },
            },
            {
                title: '',
                width: '10%',
                dataIndex: 'operation',
                render: (text, record) => {
                    return (
                        <div>
                            <Popconfirm
                                title="Sure to delete?"
                                onConfirm={() => this.deleteProject(record.key)}
                            >
                                <Button>Delete</Button>
                            </Popconfirm>
                        </div>
                    );
                },
            },
        ];

        this.pullFromDB = this.pullFromDB.bind(this);
        this.updateProject = this.updateProject.bind(this);
        this.addProject = this.addProject.bind(this);
        this.deleteProject = this.deleteProject.bind(this);

        this.pullFromDB();
    }

    isEditing = (record) => {
        return record.key === this.state.editingKey;
    };

    edit(key) {
        this.setState({ editingKey: key });
    }

    save(form, key) {
        form.validateFields((error, row) => {
            if (error) {
                return;
            }
            const newData = [...this.state.data];
            const index = newData.findIndex(item => key === item.key);
            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, {
                    ...item,
                    ...row,
                });

                this.state.da = newData[index].date
                this.state.la = newData[index].actualfilename
                this.updateProject(index)

                this.setState({ data: newData, editingKey: '' });
            } else {
                newData.push(row);
                this.setState({ data: newData, editingKey: '' });
            }
        });
    }

    cancel = () => {
        this.setState({ editingKey: '' });
    };



    handleChange = () => {
        // 
        // this.addEvent();
        let sd = [];
        //asign key to the array!
        for (var i = 0; i < Object.keys(this.state.master.medias).length; i++) {

            sd.push({
                link: Object.values(this.state.master.medias)[i],
                key: i.toString(),
            });

            // console.log("SD state!! " + JSON.stringify(this.state.sd))
            // console.log("DATA state!! " + JSON.stringify(this.state.data))
        }
        this.setState({ sd });
    }

    pullFromDB() {
        var baba;
        if (this.props.match.params.id) {
            baba = this.props.match.params.id
        }
        // We listen for live changes to our data collection in Firebase
        db.collection("eventmedia").where("event", "==", baba).onSnapshot(snapshot => {
            //data is locally available array, pulled from firestore.
            let data = [];
            snapshot.forEach(doc => {
                const todo = doc.data();
                todo.id = doc.id;
                data.push(todo);
            });

            // Sort our data based on time added
            data.sort(function (a, b) {
                return (
                    new Date(b.date).getTime() - new Date(a.date).getTime()
                );
            });

            //assign primary key
            for (var i = 0; i < data.length; i++) {
                data[i].key = i;
            }
            // console.log(data);

            // Anytime the state of our database changes, we update state
            this.setState({ data });

        })
        // var ref = db.collection("eventmedia").doc(this.props.match.params.id)
        // ref.get().then((doc) => {

        //     this.setState({
        //         master: doc.data(),
        //     });
        //     this.handleChange();
        // })


    }



    updateLinks = () => {
        for (var i = 0; i < this.state.data.length; i++) {
            if (this.state.data[i].link === "Generating link...") {
                this.openlink(i)
            }
        }
    }

    async updateProject(id) {
        await db
            .collection("eventmedia")
            .doc(this.state.data[id].id).update({
                name: this.state.na,
            })
            .then(function () {
                console.log("Document successfully updated!");

            })
            .catch(function (error) {
                // The document probably doesn't exist.
                console.error("Error updating document: ", error);
            });
    }

    async addProject(na, filename) {
        // var na = moment() 
        var bb = await db.collection("eventmedia").doc(na + filename).set({
            date: na,
            event: this.props.match.params.id,
            actualfilename: na + filename,
            name: filename,
            link: "Generating link..."
        });

    }
    async deleteProject(id) {
        var pathy = this.state.data[id].actualfilename
        var ref = storr.ref(pathy);
        // Get the download URL
        ref.delete().then(function () {
            console.log("File deleted successfully")
        }).catch(function (error) {
            console.log("Uh-oh, an error occurred!")
        });


        // alert("record.key: " + id + "todo id: " + this.state.data[id].id)
        await db
            .collection("eventmedia")
            .doc(this.state.data[id].actualfilename)
            .delete();
    }



    openlink = (key) => {
        // db.collection("eventmedia").doc(id).get().then(function (doc) {
        //     if (doc.exists) {
        //         console.log("Document data:", doc.data().name);
        //     }})
        // var bb = this.state.data[key].id
        // // Create a reference with an initial file path and name
        // var ref = storr.ref(this.state.data[key].actualfilename);
        // Get the download URL
        window.open(this.state.data[key].link, '_blank');

        // ref.getDownloadURL().then(function (url) {
        //     // Insert url into an <img> tag to "download"
        //     //open the link of the url.
        //     window.open(url, '_blank');
        //     // db.collection("eventmedia").doc(bb).update({link: url})
        // })
    }


    //OLD VERSION THAT USE AXIOS HTTP REQUEST TO CLOUD FUNCTION.
    // fileUpload = () => {
    //     var na = moment().toISOString()
    //     const formData = new FormData()
    //     formData.append('image', this.state.selectedFile, na + this.state.selectedFile.name)
    //     axios.post('https://us-central1-lemonbase-ee2df.cloudfunctions.net/uploadFile', formData, {
    //         onUploadProgress: progressEvent => {
    //             console.log(progressEvent.loaded / progressEvent.total)
    //         }
    //     })
    //         .then(res => console.log(res))
    //     this.addProject(na, this.state.selectedFile.name);
    // }

    fileUpload = () => {


    }


    blockit = () => {
        this.state.disallow = true;
        this.setState({ disallow: true })
    }


    handlefile = (event) => {
        if (event.target.files[0]) {
            if (event.target.files[0].type === 'image/png' || event.target.files[0].type === 'image/jpeg' || event.target.files[0].type == 'video/mp4') {
                console.log("accepted file format")
                if (event.target.files[0].size < 100000000) {
                    console.log(event.target.files[0])

                    var na = moment().toISOString()






                    // Create a reference with an initial file path and name

                    var jayjay = na + event.target.files[0].name;

                    var ref = storr.ref(jayjay);
                    // Get the download URL


                    // Upload file and metadata to the object 'images/mountains.jpg'
                    var uploadTask = storr.ref(na + event.target.files[0].name).put(event.target.files[0]).then(function (doc) {

                        ref.getDownloadURL().then(function (url) {
                            console.log("putting link into database" + url)
                            // Insert url into an <img> tag to "download"
                            //open the link of the url.
                            // window.open(url, '_blank');
                            db.collection("eventmedia").doc(jayjay).update({
                                link: url
                            })
                        })



                    });
                    var bb = storr.ref(na + event.target.files[0].name);

                    // // Listen for state changes, errors, and completion of the upload.
                    // uploadTask.on('state_changed', // or 'state_changed'
                    //     function (snapshot) {
                    //         // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    //         var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    //         console.log('Upload is ' + progress + '% done');
                    //         switch (snapshot.state) {
                    //             case 'paused': // or 'paused'
                    //                 console.log('Upload is paused');
                    //                 break;
                    //             case 'running': // or 
                    //                 console.log('Upload is running');
                    //                 break;
                    //         }
                    //     }, function (error) {

                    //         // A full list of error codes is available at
                    //         // https://firebase.google.com/docs/storage/web/handle-errors
                    //         switch (error.code) {
                    //             case 'storage/unauthorized':
                    //                 // User doesn't have permission to access the object
                    //                 break;

                    //             case 'storage/canceled':
                    //                 // User canceled the upload
                    //                 break;

                    //             case 'storage/unknown':
                    //                 // Unknown error occurred, inspect error.serverResponse
                    //                 break;
                    //         }
                    //     }, function () {
                    //         // Upload completed successfully, now we can get the download URL
                    //         uploadTask.snapshot.ref.getDownloadURL().then();

                    //     });

                    this.addProject(na, event.target.files[0].name);
                    this.state.checky = true
                    this.updateLinks();

                    // this.setState({ selectedFile: '' })

                } else {
                    this.blockit();
                    alert("File is too big!");
                }
            } else {
                this.blockit();
                alert("Not the accepted file type!");
            }
        } else {
            this.blockit();
            alert("No file in it!");
        }
    }
    //========================================================================================
    render() {
        const components = {
            body: {
                row: EditableFormRow,
                cell: EditableCell,
            },
        };

        const columns = this.columns.map((col) => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    inputType: col.dataIndex === 'age' ? 'number' : 'text',
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: this.isEditing(record),
                }),
            };
        });

        return (
            <div>
                <h1>{this.props.match.params.title}</h1>

                <div className="upload-btn-wrapper">
                    <button className="btn">Upload a file</button>
                    <input type="file"
                        accept="image/png, image/jpeg, video/mp4"
                        onChange={this.handlefile}
                    />
                </div>
                {/* <Button
                    className="App-add-todo-button"
                    size="large"
                    type="primary"
                    onClick={this.fileUpload}
                    disabled={this.state.disallow}
                >
                    Add a Media file
      </Button> */}
                < Table
                    components={components}
                    bordered
                    dataSource={this.state.data}
                    columns={columns}
                    rowClassName="editable-row"
                />
            </div >
        );
    }
}

export default Media;



// WEBPACK FOOTER //
// ./src/views/media.js